import { apiSlice } from './apiSlice';
const ATHLETES_URL = '/api/athletes';

export const athleteApiSlice = apiSlice.injectEndpoints({  endpoints: (builder) => ({
    fetchAthletes: builder.query({
      query: () => `${ATHLETES_URL}`, // Sends a GET request to /api/athletes
      providesTags: ['Athletes'],     // Tags the data for cache management
    }),
    fetchAthleteById: builder.query({
      query: (id) => `${ATHLETES_URL}/${id}`, // Sends a GET request to /api/athletes/:id
      providesTags: (result, error, id) => [{ type: 'Athletes', id }],
    }),
    fetchAthleteByUserId: builder.query({
      query: (userOrRequest) => {
        const userId = typeof userOrRequest === 'object' ? userOrRequest?.userId : userOrRequest;
        const leagueId = typeof userOrRequest === 'object' ? userOrRequest?.leagueId : undefined;
        const searchParams = new URLSearchParams();

        if (leagueId) {
          searchParams.set('leagueId', leagueId);
        }

        const querySuffix = searchParams.toString() ? `?${searchParams.toString()}` : '';
        return `${ATHLETES_URL}/user/${userId}${querySuffix}`;
      },
      providesTags: (result, error, userOrRequest) => {
        const userId = typeof userOrRequest === 'object' ? userOrRequest?.userId : userOrRequest;
        return [{ type: 'Athletes', userId }];
      },
    }),
    fetchAthletesByDraftedTeamId: builder.query({
      query: (teamId) => `${ATHLETES_URL}/drafted-team/${teamId}`, 
      providesTags: (result, error, teamId) => [{ type: 'Athletes', id: `drafted-team-${teamId}` }],
    }),
    addAthlete: builder.mutation({
      query: (newAthlete) => ({
        url: `${ATHLETES_URL}`,
        method: 'POST',
        body: newAthlete,
      }),
      invalidatesTags: ['Athletes'],  // Invalidates 'Athletes' tag to refetch data
    }),
    updateAthlete: builder.mutation({
      query: (athlete) => ({
        url: `${ATHLETES_URL}/${athlete.id}`,
        method: 'PUT',
        body: athlete,
      }),
      invalidatesTags: ['Athletes'],  // Refetches athletes on update
    }),
    deleteAthlete: builder.mutation({
      query: (athleteId) => ({
        url: `${ATHLETES_URL}/${athleteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Athletes'],  // Refetches athletes on deletion
    }),
    fetchUser: builder.query({
      query: (id) => `/users/${id}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the endpoints
export const {
  useFetchAthletesQuery,
  useFetchAthleteByIdQuery,
  useFetchAthleteByUserIdQuery,
  useFetchAthletesByDraftedTeamIdQuery,
  useAddAthleteMutation,
  useUpdateAthleteMutation,
  useDeleteAthleteMutation,
  useFetchUserQuery
} = athleteApiSlice;